export const UDL_INDEX_EVENT_NAMES = {
  VIEWED_PAGE: 'Viewed Strategy Index',
  TOGGLED_GUIDELINE: 'Toggled UDL Guideline',
  TOGGLED_CHECKPOINT: 'Toggled UDL Checkpoint',
  OPENED_STRATEGY_LINK: 'Opened UDL Strategy Link'
}
